export const getAuthingConfig = (namespace?: string) => {
  return namespace ? {
    AUTHING_APP_ID: process.env.CLEWORD_AUTHING_TENANT_APP_ID, 
    AUTHING_APP_HOST: process.env.CLEWORD_AUTHING_TENANT_APP_HOST
  } : {
    AUTHING_APP_ID: process.env.CLEWORD_AUTHING_APP_ID,
    AUTHING_APP_HOST: process.env.CLEWORD_AUTHING_APP_HOST
  }
}